import { type TFunction } from '!/i18n'
import type { UiCategoryWithChannels } from '@/interfaces'
import { extendMediaItemByLabelPriceTvChannel } from '@/tools'
import type { CategoryWithChannels } from '@setplex/tria-api'
import { type AdjustPurchaseableFn } from '~/features/payment/sse-purchases'

export const formatCategoryWithChannelsToUi = (
  data: CategoryWithChannels | null,
  adjust: AdjustPurchaseableFn,
  t: TFunction
): UiCategoryWithChannels | null => {
  if (!data) return null

  const formattedContent = data.content.map((channel) =>
    extendMediaItemByLabelPriceTvChannel(adjust(channel))
  )

  const name = data.id === 0 ? t('all') : data.name

  return {
    ...data,
    name,
    content: formattedContent,
  }
}
